// TEMPORARY: the dictation key lives in the browser, the way the prototype keeps
// it, so nobody has to put a secret in .env. Goes away with BTS-492.

export const VOICE_KEY_STORAGE_KEY = "voiceInputOpenAiKey";

/** Rejects obvious typos and pasted junk without pretending to validate the key. */
export const looksLikeApiKey = (value: string): boolean => /^sk-\S{16,}$/.test(value.trim());

export const readVoiceKey = (): string => {
	try {
		return localStorage.getItem(VOICE_KEY_STORAGE_KEY)?.trim() || "";
	} catch {
		// Private mode and blocked site data both throw rather than return null.
		return "";
	}
};

export const saveVoiceKey = (value: string): void => {
	try {
		localStorage.setItem(VOICE_KEY_STORAGE_KEY, value.trim());
	} catch {
		/* nothing to do: the caller already has the key in memory for this session */
	}
};

export const clearVoiceKey = (): void => {
	try {
		localStorage.removeItem(VOICE_KEY_STORAGE_KEY);
	} catch {
		/* see saveVoiceKey */
	}
};

/** Last four characters, for showing which key is stored without revealing it. */
export const maskKey = (value: string): string => {
	const key = value.trim();
	return key.length > 4 ? `…${key.slice(-4)}` : key;
};
